import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { TipoProcessoDocumentoLocalFrmComponent } from '../tipo-proc-doc-loc-frm/tipo-proc-doc-loc-frm.component';

@Component({
  selector: 'app-tipo-proc-doc-loc-edicao',
  templateUrl: './tipo-proc-doc-loc-edicao.component.html',
  styleUrls: ['./tipo-proc-doc-loc-edicao.component.css'],
})
export class TipoProcessoDocumentoLocalEdicaoComponent implements OnInit {
  @ViewChild(TipoProcessoDocumentoLocalFrmComponent, { static: true }) frm: TipoProcessoDocumentoLocalFrmComponent;

  @Output()
  public onSalvar = new EventEmitter<void>();

  display = false;

  constructor() {}

  ngOnInit(): void {}

  salvar() {
    throw new Error('Método não implementado.');
    // this.frm.salvar().then(
    //   () => { this.display = false; this.onSalvar.emit(); }
    // );
  }

  showDialog() {
    this.display = true;
    this.frm.iniciarAlteracaoPorId();
  }

  voltar() {
    this.display = false;
  }
}
